/** Código de términos de pago que identifica a los proveedores de contado en BC. */
export const TERMINO_PAGO_CONTADO = 'CONTADO';
//# sourceMappingURL=PropuestaPago.js.map